export const smallCircle = {
    id: 'small-circle',
    width: 200,
    height: 200,
    d: `M 100, 100
        m -75, 0
        a 75,75 0 1,0 150,0
        a 75,75 0 1,0 -150,0`,
};
